module.exports = __webpack_public_path__ + "img/cz.4f812061.svg";